<template>
    <div class="container-fluid">
        <div class="payroll-container">
            <PayrollTable />
        </div>
    </div>
</template>

<script>
import PayrollTable from "src/components/PayrollManagement/PayrollSummary/PayrollTable.vue";
import firebaseLib from "firebase";
import "firebase/database";
import firebase from "../../assets/config/firebase";

export default {
    components: {
        PayrollTable,
    },
    data() {
        const user = this.$store.state.auth.user;
        return {
            isAdmin: user && user.role === "admin",
        };
    },
    methods: {
        fetchAllUsersRealTime() {
            firebaseLib
                .database()
                .ref("users")
                .on("child_changed", data => {
                    if (data.val()) {
                        const allUsers = this.$store.state.auth.allUsers;
                        const targetIndex = _.findIndex(allUsers, { uid: data.key });
                        if (targetIndex !== -1) {
                            allUsers[targetIndex] = { ...data.val(), uid: data.key };
                            this.$store.commit("setAllUsers", [...allUsers]);
                        }
                    }
                });
        },
    },
    async created() {
        const company = this.$store.state.auth.company;
        try {
            if (!firebase.apps.length) {
                await firebase.configureFirebase(company.firebase);
                await this.fetchAllUsersRealTime();
            }
        } catch (e) {
            console.error("Firebase initialization error:", e.message);
        }
    },
};
</script>

<style scoped>
.payroll-container {
    padding:  20px 20px 65px 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/PayrollManagement/index.vue